<script setup>
    import Store from '../store';
    import Button from 'primevue/button';
    import { FilterMatchMode, FilterOperator } from 'primevue/api';
    import DataTable from 'primevue/datatable';
    import InputText from 'primevue/inputtext';
    import Column from 'primevue/column';
    // import Dialog from 'primevue/dialog';
    // import Checkbox from 'primevue/checkbox';
    import { ref, onBeforeMount, onMounted } from 'vue';
    import api from '../lib/serverApi';
    import dialogs from '../lib/dialogs';

    const entitiesList = ref(null);
    const selectionEntitie = ref(null);
    const filters = ref(null);
    const loading = ref(false);

    onBeforeMount(() => {
        Store.commit('SET_FORM_HEADER', 'Администрирование > Сущности');
        initFilters();
    });

    onMounted(() => {
        loadEntitieList();
    });

    async function loadEntitieList() {
        loading.value = true;
        try {
            entitiesList.value = await api.getEntitiesConfig(['*']);
        } catch(error) {
            dialogs.showException(error);
        }
        loading.value = false;
    }

    const initFilters = () => {
        filters.value = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            entitieId: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            description: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        };
    }


</script>

<template>
    <div class="formPanel">
        <div class="mb-2">
            <Button icon="pi pi-plus" label="Добавить" @click="onAddButton()" class="mr-1" />
            <Button icon="pi pi-pencil" label="Изменить" @click="onChangeButton()" class="mx-1" />
            <Button icon="pi pi-trash" label="Удалить" @click="onDeleteButton()" class="mx-1" severity="danger" />
        </div>
        <DataTable
            :value="entitiesList"
            :paginator="true"
            stripedRows
            v-model:selection="selectionEntitie"
            selectionMode="single"
            class="p-datatable-sm"
            :rows="20"
            dataKey="entitieId"
            :rowHover="true"
            v-model:filters="filters"
            filterDisplay="menu"
            :loading="loading"
            :filters="filters"
            responsiveLayout="scroll"
            :globalFilterFields="['entitieId', 'description']"
        >
            <template #header>
                <div class="flex justify-content-between flex-column sm:flex-row">
                    <Button type="button" icon="pi pi-filter-slash" label="Очистить фильтр" class="p-button-outlined" @click="initFilters()" />
                    <span class="p-input-icon-left" style="width: 300px">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="текст поиска" style="width: 100%" />
                    </span>
                </div>
            </template>
            <template #empty> Нет данны для отображения. </template>
            <template #loading> Загрузка данных. Пожалуйста подождите. </template>
            <Column field="entitieId" header="Идентификатор" style="min-width: 12rem">
                <template #body="{ data }">
                    {{ data.entitieId }}
                </template>
                <template #filter="{ filterModel }">
                    <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Поиск по идентификатору" />
                </template>
            </Column>
            <Column field="description" header="Описание" style="min-width: 12rem">
                <template #body="{ data }">
                    {{ data.description }}
                </template>
                <template #filter="{ filterModel }">
                    <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Поиск по описанию" />
                </template>
            </Column>
            <Column field="type" header="Тип" style="min-width: 5rem">
                <template #body="{ data }">
                    {{ data.type }}
                </template>
            </Column>
            <Column field="mode" header="Доступ" style="min-width: 5rem">
                <template #body="{ data }">
                    {{ data.mode }}
                </template>
            </Column>
            <Column field="archiveMode" header="Архив" style="min-width: 5rem">
                <template #body="{ data }">
                    {{ data.archiveMode }}
                </template>
            </Column>
            <Column field="onChangeScript" header="Сценарий при изменнии" style="min-width: 12rem">
                <template #body="{ data }">
                    {{ data.onChangeScript }}
                </template>
            </Column>
        </DataTable>
    </div>

</template>

<style scoped>
</style>